import { GraduationCapIcon, OnlineLearningIcon, StoreIcon } from "../icons"

const PILLARS = [
  {
    title: "Scholarships first",
    description:
      "Full scholarships that transition children from public schools into partner private schools — fees, books, uniforms and materials, all covered.",
    icon: <GraduationCapIcon />,
  },
  {
    title: "A learning hub, next",
    description:
      "Soft skills — public speaking, confidence, leadership. Hard skills — tech and business. A future home for the scholars we raise.",
    icon: <OnlineLearningIcon />,
  },
  {
    title: "Women, alongside",
    description:
      "Education on business principles and micro-grants for mothers and women entrepreneurs building around the children we serve.",
    icon: <StoreIcon />,
  },
]

export function CorePillars() {
  return (
    <section className="bg-cream-50 py-4 pb-[18px] lg:py-12 lg:pb-[58px]">
      <div className="public-container grid gap-2 md:grid-cols-3 lg:gap-12">
        {PILLARS.map((pillar) => (
          <div key={pillar.title} className="grid">
            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-forest-950 text-white lg:h-12 lg:w-12">
              {pillar.icon}
            </span>
            <h2 className="text-xl font-bold leading-8 text-ink mt-3">{pillar.title}</h2>
            <p className="mt-1 text-base leading-[1.3] text-ink sm:text-lg lg:leading-relaxed">{pillar.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
